export default "__VITE_ASSET__D1zMzWub__"